import { v4 as uuid } from 'uuid';
import { tonyStark } from '../patients';
import { mickAbae } from '../providers';
import { editableEncounter } from './editableEncounter';

export const encounterIdE = uuid();

export const encounterE = {
  patient: tonyStark,
  encounterId: encounterIdE,
  provider: mickAbae,
  assessments: [{ description: 'assessments description', code: 'assessments code' }],
  plan: {
    procedureCodes: [{ code: 'procedure code', description: 'procedure description' }],
    generalNotes: 'plan general notes',
  },
  encounterNotes: {
    generalNotes: 'encounter notes',
  },
  patientInstructions: {
    generalNotes: 'patient instructions',
  },
  identifiers: {
    ehrEncounterId: encounterIdE,
  },
  basicInformation: {
    encounterDateOfService: '2021-01-01',
    type: 'encounter type',
    status: 'UNLOCKED',
  },
  subjective: {
    generalNotes: 'subjective general notes',
    chiefComplaintNotes: 'chief complaint notes',
    historyOfPresentIllnessNotes: 'history of present illness notes',
    reviewOfSystemsNotes: 'review of systems notes',
  },
  objective: {
    generalNotes: 'objective general notes',
    physicalExamNotes: 'physical exam notes',
  },
  editableEncounter,
};
